import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import AsyncSelect from 'react-select/async';
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport, FaEraser, FaTrash } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, getCurrentUser, formataDataHoraExibicao } from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';
import AudioCell from "./AudioCell";

class GotoConnect extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaGotoConnect = this.buscaGotoConnect.bind(this);
        this.limpaFiltro = this.limpaFiltro.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            protocolo: "",
            filtro_programa_id: '',
            filtro_programa_nome: '',
            num_telefone: "",
            estado: "",
            data_inicio_atendimento: "",
            data_fim_atendimento: "",
            filtro_data_inicio: "",
            filtro_data_fim: "",
            page_numb: 1,
            loading: true,
        };
    }

    componentDidMount(){
        this.consultaGotoConnect(this.state.busca, this.state.page_numb)
    }

    consultaGotoConnect(page_numb = 1) {
        let dados_usuario = getCurrentUser();
        
        let url = `/gotoconnect/historico_ligacoes/?page=${page_numb}`;

        if (this.state.num_telefone) {
            url += `&num_telefone=${this.state.num_telefone}`;
        }

        if (dados_usuario['ambiente_programa_id']) {
            url += `&programa_id=${dados_usuario['ambiente_programa_id']}`;
        } else if(this.state.filtro_programa_id){
            url += '&programa_id='+this.state.filtro_programa_id
        }

        if (this.state.filtro_data_inicio) {
            url += '&data_inicio=' + this.state.filtro_data_inicio + ' 00:00:00';
        }

        if (this.state.filtro_data_fim) {
            url += '&data_fim=' + this.state.filtro_data_fim + ' 23:59:59';
        }

        this.setState({ loading: true }); 
        
        api.get(url)
            .then(response => {
                this.setState({
                    loading: false,
                    error: "",
                    listRegistros: response.data,
                    page_numb
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar GotoConnect, tente novamente.';
        
                if (error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }
        
                this.setState({
                    loading: false,
                    error: erro_msg
                });
            });
    }   

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                {/*<td>{item.id}</td>*/}
                <td>{item.legId}</td>
                <td>{item.data_inicio ? formataDataHoraExibicao(item.data_inicio) : '-'}</td>
                <td>{item.data_resposta ? formataDataHoraExibicao(item.data_resposta) : '-'}</td>
                <td>{item.direcao}</td>
                <td>{item.duracao}</td>
                {/*<td>{item.causa_desligamento}</td>
                <td>{item.chave_usuario}</td>
                <td>{item.dono_num_telefone}</td>*/}
                <td>{item.caller_numero} 
                    {item.caller_nome ? ` (${item.caller_nome})` : ''}
                </td>
                <td>
                    {item.callee_numero} 
                    {item.callee_nome ? ` (${item.callee_nome})` : ''}
                </td>
                <td>
                    {item.link_arquivo_audio && <AudioCell url={item.link_arquivo_audio} />}               
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={8}>Nenhum gotoconnect encontrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaGotoConnect(num_page)
    };
    
    buscaGotoConnect(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaGotoConnect(this.state.busca)
    };

limpaFiltro() {
    // Limpar tanto os estados temporários quanto os efetivos
    this.setState({
        filtro_programa_id: '',
        num_telefone: '',
    }, () => {
        this.consultaGotoConnect('', '', '', '', '', '', 1);
    });
}

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                filtro_programa_id: "", 
                filtro_programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1 
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
            }));
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    carregaProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    render() {
        if (!hasPerm('view_goto_connect')) {
            return <Navigate to='/sem-permissao' />
        }

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">GotoConnect</h4>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaGotoConnect}>

                                                <Row>
                                                    <Col> 
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Programa</Form.Label>
                                                            <AsyncSelect          
                                                                cacheOptions
                                                                loadOptions={this.carregaProgramas}
                                                                defaultOptions
                                                                name="programa_id"
                                                                placeholder={'Buscar programa...'}
                                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                                                value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Número de Telefone</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="num_telefone"
                                                                value={this.state.num_telefone}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Número de Telefone"
                                                                aria-label="Número de Telefone"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Data Início</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="filtro_data_inicio"
                                                                value={this.state.filtro_data_inicio}
                                                                onChange={e => this.handleChangeFiltros(e, 'filtro_data_inicio')}

                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Data Fim</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="filtro_data_fim"
                                                                value={this.state.filtro_data_fim}
                                                                onChange={e => this.handleChangeFiltros(e, 'filtro_data_fim')}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>

                                                <Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                    <FaEraser /> Limpar Filtro
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    {/*<th>ID</th>*/}
                                    <th>Leg ID</th>
                                    <th>Data Início</th>
                                    <th>Data Resposta</th>
                                    <th>Direção</th>
                                    <th>Duração</th>
                                    {/*<th>Causa Desligamento</th>
                                    <th>Chave Usuário</th>
                                    <th>Número Telefone</th>*/}
                                    <th>Quem Ligou</th>
                                    <th>Quem Atendeu</th>
                                    <th>Áudio</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={8}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={8}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(GotoConnect);